import { Zap } from "lucide-react";
import { MarkdownEditor } from "../../../../../components/MarkDownEditor";
import {
  DESCRIPTION_INPUT_CLASS,
  DESCRIPTION_TEXTAREA_CLASS,
  FieldLabel,
  FormSection,
} from "../../../../../components/propertyDescription/descriptionUi";
import { HelpText, IAButton } from "../twStyles";

type Props = {
  title: string;
  briefDescription: string;
  description: string;
  note: string | null;
  isGeneratingDescription: boolean;
  onTitleChange: (value: string) => void;
  onBriefDescriptionChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onGenerateDescription: () => void;
  onNoteChange: (value: string) => void;
};

export default function PublicationSection({
  title,
  briefDescription,
  description,
  note,
  isGeneratingDescription,
  onTitleChange,
  onBriefDescriptionChange,
  onDescriptionChange,
  onGenerateDescription,
  onNoteChange,
}: Props) {
  return (
    <FormSection title="Anúncio">
      <FieldLabel>Título</FieldLabel>
      <input
        type="text"
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        className={DESCRIPTION_INPUT_CLASS}
      />
      <div className="mt-4">
        <FieldLabel>Resumo para IA</FieldLabel>
        <textarea
          className={`${DESCRIPTION_TEXTAREA_CLASS} min-h-[72px]`}
          value={briefDescription}
          onChange={(e) => onBriefDescriptionChange(e.target.value)}
        />
        <IAButton
          type="button"
          className="mt-2 h-9 px-3 py-0 text-xs"
          disabled={isGeneratingDescription || briefDescription.length < 5}
          onClick={onGenerateDescription}
        >
          <Zap className="h-3.5 w-3.5" aria-hidden />
          {isGeneratingDescription ? "Gerando..." : "Gerar descrição com IA"}
        </IAButton>
      </div>
      <div className="mt-4">
        <FieldLabel>Descrição completa</FieldLabel>
        <MarkdownEditor value={description} onChange={onDescriptionChange} />
        <HelpText>
          A descrição utiliza Markdown.
          <a
            href="https://www.markdownguide.org/basic-syntax/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Aprenda o básico aqui.
          </a>
        </HelpText>
      </div>
      <div className="mt-4">
        <FieldLabel>Observação interna</FieldLabel>
        <textarea
          className={`${DESCRIPTION_TEXTAREA_CLASS} min-h-[88px]`}
          maxLength={2000}
          value={note ?? ""}
          onChange={(e) => onNoteChange(e.target.value)}
        />
      </div>
    </FormSection>
  );
}
